module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Manuela Francke Personal- und Organisationsberatung","short_name":"Manuela Francke","start_url":"/","background_color":"#663399","theme_color":"#663399","display":"minimal-ui","icon":"src/images/favicon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"964a6fcd5dcc3fef090f01395eaf9655"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
